import { defineComponent as l, ref as t } from "vue";
import s from "./td-longtail-vue-components265.js";
const p = /* @__PURE__ */ l({
  __name: "modal",
  props: {
    customClass: { default: void 0 },
    ariaLabel: { default: void 0 },
    dataTealiumRel: { default: void 0 },
    headingText: { default: void 0 },
    teleportTarget: { default: "globals" },
    noMaxWidth: { type: Boolean },
    closeOnBackdrop: { type: Boolean },
    closeAutofocus: { type: Boolean, default: !1 },
    disableFocusTrap: { type: Boolean }
  },
  emits: ["onCloseModal"],
  setup(i, { expose: a }) {
    const o = t(null), e = () => o.value?.openDialog();
    return a({
      openDialog: e,
      closeDialog: () => o.value?.closeDialog()
    }), { __sfc: !0, baseDialog: o, openDialog: e, BaseDialog: s };
  }
});
export {
  p as default
};
